module.exports = __webpack_public_path__ + "static/media/haute14B.5e37c381.jpg";